import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../../common/components";
import "./lead-value-filter.scss";

type RangeFilterProps = {
  minValue: string;
  maxValue: string;
  onValueChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    type: "min" | "max"
  ) => void;
  isLeadValueEnabled?: boolean;
  minError?: string;
  maxError?: string;
  label?: string;
};

const LeadValueFilter: React.FC<RangeFilterProps> = ({
  minValue,
  maxValue,
  onValueChange,
  isLeadValueEnabled,
  minError,
  maxError,
}) => {
  return (
    <div className="range-filter-wrapper">
      <div className="range-filter-form">
        <div className="text-inputs">
          <div className="form-group">
            <TextInputComponent
              type="text"
              isNumber
              fieldName="min"
              placeholder="Enter Min Value"
              optional={false}
              value={minValue}
              onChange={(e: any) => onValueChange(e, "min")}
              blockInvalidChars={true}
            />
            {minError && <span className="error-text">{minError}</span>}
          </div>

          <div className="form-group">
            <TextInputComponent
              type="text"
              isNumber
              fieldName="max"
              placeholder="Enter Max Value"
              optional={false}
              value={maxValue}
              onChange={(e: any) => onValueChange(e, "max")}
              blockInvalidChars={true}
            />
            {maxError && <span className="error-text">{maxError}</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadValueFilter;
